module.exports = __webpack_public_path__ + "img/IMG_8157_FoamcoreMatted.65ee6130.jpg";